import React, { useEffect, useContext, useState } from 'react';
import findIndex from 'lodash/findIndex';
import { LocationContext } from '@/context/location.context';

const StateContext = React.createContext([{}, () => {}]);

const StateProvider = ({ children }) => {
  const [currentState, setCurrentState] = useState({});
  const [currentStateIndex, setCurrentStateIndex] = useState();
  const [answers, setAnswers] = useState({});
  const [config, setConfig] = useState();
  const locationContext = useContext(LocationContext);

  useEffect(() => {
    locationContext.initLocation();
  }, []);

  useEffect(() => {
    if (config && currentState) {
      let newIndex = findIndex(config.pages, (page) => {
        return page.name == currentState.name;
      });
      setCurrentStateIndex(newIndex);
    }
  }, [currentState]);

  useEffect(() => {
    if (config && typeof currentStateIndex != 'undefined') {
      setCurrentState(config.pages[currentStateIndex]);
    }
  }, [currentStateIndex]);

  const createQueryString = (obj, encode = true) => {
    function getPathToObj(obj, path = []) {
      let result = [];
      for (let key in obj) {
        if (!obj.hasOwnProperty(key)) return;
        //deep copy
        let newPath = path.slice();
        newPath.push(key);
        let everyPath = [];
        if (typeof obj[key] === 'object') {
          everyPath = getPathToObj(obj[key], newPath);
        } else {
          everyPath.push({
            path: newPath,
            val: obj[key]
          });
        }
        everyPath.map((item) => result.push(item));
      }
      return result;
    }

    function composeQueryString(paths) {
      let result = '';
      paths.map((item) => {
        let pathString = '';
        if (item.path.length > 1) {
          pathString = item.path.reduce((a, b, index) => {
            return a + '[' + b + ']';
          });
        } else {
          pathString = item.path[0];
        }

        if (!item.val) {
          pathString = '';
        } else if (result) {
          pathString = '&' + pathString + '=' + item.val;
        } else {
          pathString = '?' + pathString + '=' + item.val;
        }

        result += pathString;
      });

      return result;
    }

    const str = composeQueryString(getPathToObj(obj));
    return encode === true ? encodeURI(str) : str;
  };

  const stateUrlFromAnswers = (search) => {
    var searchObject = {};
    searchObject.page = 1;
    searchObject['query[tags]'] = encodeURIComponent(answers.tags);
    searchObject['query[evictionOptions]'] = encodeURIComponent(answers.evictionOptions);

    searchObject['lat'] = locationContext.location.lat;
    searchObject['long'] = locationContext.location.lng;
    searchObject['county'] = locationContext.location.county;
    // currently treating 'none' as standard property mapping to community-available-all
    searchObject['properties'] = answers?.properties?.join(',');
    return createQueryString(searchObject);
  };

  return (
    <StateContext.Provider
      value={{
        currentState: currentState,
        setCurrentState: setCurrentState,
        currentStateIndex: currentStateIndex,
        setCurrentStateIndex: setCurrentStateIndex,
        answers: answers,
        setAnswers: setAnswers,
        config: config,
        setConfig: setConfig,
        stateUrlFromAnswers: stateUrlFromAnswers
      }}
    >
      {children}
    </StateContext.Provider>
  );
};

export { StateContext, StateProvider };
